// 会员优惠类型
export const MemberPrivTypes = {
  DISCOUNT: 1, // 折扣
  REDUCE: 2, // 立减
  UNIFIED_DISCOUNT: 3, // 统一折扣
};

// 但商品优惠类型
export const SiglePrivTypes = {
  REDUCE: 1, // 立减
  DISCOUNT: 2, // 折扣
};

// 优惠劵使用类型
export const CouponUseTypes = {
  ALL: 1, // 全部
  PART: 2, // 部分可用
  EXCEPTION: 3, // 部分不可用
};

// 优惠劵优惠类型
export const CouponPrivTypes = {
  REDUCE: 1, // 立减,
  DISCOUNT: 2, // 折扣
};

// 进位规则
export const CarryTypes = {
  ROUND: 1, // 四舍五入
  CEIL: 2, // 无条件进位
  FLOOR: 3, // 无条件舍去
  THREE_SEVEN: 4, // 37进位
};

// 堂食就餐类型
export const DinnerForms = {
  DINNER: 0, // 正餐
  FAST: 1, // 快餐
};

// 订单详情开票功能
export const Invoice = {
  OPEN: 1, // 开通
  CLOSE: 0, // 关闭
};

// 开票状态
export const InvoiceStatus = {
  DOWNLOAD: 1, // 下载状态
  OPEN: 0, // 申请开票状态
  LOADING: 2, // 正在开票中状态
};

export const CouponTypes = {
  OFFERVALUE: 1, // 减满券
  ZKVALUE: 2, // 折扣券
  GIFTVALUE: 3, // 礼品券
  FACEVALUE: 4, // 代金券
};

export const DeliveryWay = {
  ALL: 0, // 外卖+自提
  SEND: 1, // 外卖
  SELF: 2, // 自提
};

// 非定时送达
export const OnlyPromptlyDelivery = {
  OPEN: 1, // 开启
  CLOSE: 0, // 不开启
};

// U鼎品牌编号
export const UdingBrandId = '41173';

// 海底捞品牌编号
export const HDLBrandId = '32467';

// cookie 品牌编号名
export const kryApiBrandId = 'kry-api-brand-id';

// 单商品优惠类型
export const SinglePrivTypes = {
  BENEFIT: 1,
  MEMBER: 3, // 会员
};

// 订单子来源
export const OrderChildSource = {
  WX: 32,
  ALIPAY: 34,
  KOUBEI: 36,
  OTHER: 43,
  HDL: 37,
  HDLHOT: 38,
  HDLWS: 39,
  HDLCOOPERATION: 900,
  HDLBACKUPONE: 901,
  HDLBACKUPTWO: 902,
  HDLBACKUPTHREE: 1135,
  HDLBACKUPFOUR: 1136,
  HDLBACKUPFIVE: 1137,
  CMB: 28,
  WX_MINI: 35,
  ALIPAY_MINI: 42,
  CCB_APP: 54, // TODO: 随便写的，估计后面订单组会指定一个值
  EBU: 162, // ebu 饿了么企餐
};

/**
 * 订单子来源参数
 */

export const HDLPublicParm = {
  HDLHOT: 1,
  HDLWS: 2,
  HDLCOOPERATION: 3,
  HDLBACKUPONE: 4,
  HDLBACKUPTWO: 5,
  HDLBACKUPTHREE: 6,
  HDLBACKUPFOUR: 7,
  HDLBACKUPFIVE: 8,
};

export const DinnerType = {
  TAKEOUT: 'WM',
  DINNERHALL: 'TS',
};

/**
 * 成长类型
 */
export const StoreGrownTypes = {
  STOREDVALUE: 1, // 储值消费获取成长值
  RECHARGE: 2, // 充值时获取成长值
  CONSUME: 3, // 普通消费获取成长值
};

/**
 * 折扣后的最小金额
 */
export const MinDiscountedAmount = 0.01;

/**
 * 快餐选择人数开关类型
 */
export const InputSnackTableCounts = {
  MUST: 2, // 必须选人数
  CANT: 0, // 不能选人数
  ABLE: 1, // 非强制选人数
};

/**
 * 人数限制范围
 */
export const MaxCustomerCount = 99;

/**
 * mine-coupon-list pageSize
 */
export const MineCouponListPageSize = 10;

/**
 * 单菜品最大可点份数
 */
export const MaxOrderedDishCount = 99999;

/**
 * 折扣项 calcWay
 */
export const CalcWay = {
  DISCOUNT: 1,
  PEOPLE: 2,
  REGULAR: 3,
  STAGE: 7, // 阶梯计费
};

/**
 * 订单状态
 * tradeStatus: 2, // 1:待确认 2:挂单 3:已确认 4:已完成(全部支付) 5:已退货 6:已作废 7：已拒绝 8:取消
 * tradePayStatus: 2, // 1:未支付 2：支付中 3:已支付 4：退款中 5: 已退款 6：退款失败, 7: 已支付确认
 */
export const TradeStatus = {
  AWAIT: 1,
  HANGUP: 2,
  ASSURE: 3,
  FINISH: 4,
  RETURNED: 5,
  INVALID: 6,
  REFUSED: 7,
  CANCEL: 8,
};

export const TradePayStatus = {
  NOTPAY: 1,
  PAYING: 2,
  PAID: 3,
  REFUND: 4,
  REFUNDED: 5,
  REFUNDFAIL: 6,
  CONFIRMED: 7,
};

export const OrderStatusText = {
  '0': '待收锅',
  '1': '收锅中',
  '2': '收锅完成',
};

/**
 * 优惠券保存类型
 */
export const CouponSubmitDataTypes = {
  SYSTEM: 1, // 系统券
  WECHAT: 2, // 微信卡券
};

/**
 * BookOrderStatus
 * 订单状态(未封装), -1:用户未到店,1:用户到店,2:用户离店,9:已取消,-2:未处理,-3:已拒绝,-4:逾期未到店
 */
export const BookOrderStatus = {
  USERNOTARRIVAL: -1, // 未到店
  USERARRIVAL: 1, // 用户到店
  USERLEAVESHOP: 2, // 用户离店
  CANCEL: 9, // 已取消
  NOTDEAL: -2, // 未处理
  REFUSE: -3, // 已拒绝
  TIMEOUT: -4, // 逾期未到店
  ASSURE: 3, // 已确认
};

/**
 * BookingStatus
 * 解析之后的book状态
 */
export const BookingStatus = {
  BOOKNOTARRIVAL: 'book-not-arrival', // 未到店
  BOOKSUCCESS: 'book-success', // 预定成功
  BOOKFAIL: 'book-fail', // 预定失败
  BOOKUNPAID: 'book-unpaid', // 未支付
  BOOKCONFIRMING: 'book-confirming', // 确认中
  BOOKCANCEL: 'book-cancel', // 取消预订
  BOOKARRIVALED: 'book-arrived', // 已到店
  BOOKSURE: 'book-sure', // 已确认
  BOOKREFUSED: 'book-refused', // 已拒绝
};

/**
 * QueueOrderStatus
 * 排队状态 0:排队中;1:入场;-1作废;-2取消
 */
export const QueueOrderStatus = {
  QUEUING: 0, // 排队中
  ENTER: 1, // 入场
  DUMP: -1, // 作废
  CANCEL: -2, // 取消
};

/**
 * applyProductType 整单商品优惠
 * 1: '所有商品可用', 2: '部分商品可用', 3: '部分商品不可用',
 */
export const ApplyProductType = {
  ALLPRODUCT: 1, // 所有商品可用
  PARTPRODUCT: 2, // 部分商品可用
  NOTPARTPRODUCT: 3, // 部分商品不可用
};

/**
 * 换购活动类型，换购还是赠送
 * 1: '赠送', 2: '加价换购'
 */
export const PurchasedType = {
  PRESENT: 1,
  PURCHASE: 2,
};

/*
 * WmPageTpl 外卖业态
 */
export const WmPageTpl = {
  WM: 'wm',
  XLS: 'xls',
};

/*
 * 外卖门店取餐方式
 */
export const TakeoutMethod = {
  OPEN: 1, // 开启
  CLOSE: 0, // 关闭
};

/**
 * effectType 是否加入订单 1 加入  2 不加入
 */
export const EffectType = {
  ADD: 1,
  NOADD: 2,
};

/**
 * EffectDiscountType 税率计算金额来源 1 实付金额 2 菜品总价 + 各种附加费
 */
export const EffectDiscountType = {
  AFTER: 1,
  BEFORE: 2,
};

/**
 * 支付方式
 */
export const PayWay = {
  ONLINE: '2', // 在线支付
  OFFLINE: '1', // 线下支付
};

/*
 * 正餐制作状态
 */
export const DishMakeStatus = {
  AWAIT: 0,
  CUT: 1,
  MAKE: 2,
  DONE: 3,
  OBSOLETE: 4,
};

/**
 * 正餐状态
 */
export const DishStatus = {
  UNCHECK: 1,
  CHECKED: 2,
  REFUSED: 3,
};

/*
 * 菜品子属性类别
 */
export const DishPropertyTypes = {
  PRACTICE: 1, // 做法
  CUSTOMLABEL: 2, // 自定义标签
  REMARK: 3, // 备注
  SPECIFICATION: 4, // 规格
};

/*
 * 支付方式排序
 */
export const PaymentMethodsSort = {
  BALANCEPAY: 1,
  STOREANDPAY: 2,
  WEIXINPAY: 3,
  ALIPAY: 4,
  BAIDUPAY: 5,
  ANTCREDITPAY: 5, // 花呗
  UEPAY: 6,
  BOCPAY: 7, // bocPay
  TOUCHNGOPAY: 8, // touchngoPay
  MPAY: 9,
};

/*
 * 后端返回已经支付的记录
 * https://conf.shishike.com/pages/viewpage.action?pageId=18908207
 */
export const PaidRecordMethod = {
  BALANCEPAY: -1,
  WEIXINPAY: -5,
  ALIPAY: -6,
  PREPAY: -42,
};

/*
 * 服务卡状态
 */
export const ShopCardOrderStatus = {
  AWAITCOMMERCIALCONFIRM: 1, // 等待商户确认
  ORDERCONFIRMED: 3, // 订单已确认
  AWAITCOMMERCIALCONFIRMADDDISH: 300, // 等待商户确认加菜
  ORDERDONE: 4, // 订单已完成
  ORDEROBSOLETE: 6, // 订单被作废
  ORDERREFUSED: 7, // 订单被拒绝
};

/*
 * 储值方式 1 正常储值 2 小额储值
 */
export const StoreType = {
  NORMALSTORE: 1,
  SMALLSTORE: 2,
};

/*
 * 储值赠送方式 1 赠送固定金额 2 赠送百分比
 */
export const SendStoreType = {
  SENDFIXVALUE: 1,
  SENDPERCENTVALUE: 2,
};

/**
 * 微信分享来源 1 门店首页 2 商品详情页 3 会员注册页 4 品牌首页
 */
export const WxSharEventEntry = {
  SHOP: 1,
  DETAIL: 2,
  MEMBER: 3,
  BRAND: 4,
};
/*
 * 优惠券入口 1 点餐页 2 订单详情页 3 自动发券页
 */
export const CouponEntry = {
  DISH: 1,
  DISHDETAIL: 2,
  RECEIVED: 3,
};

/**
 * 海外环境判定
 */
export const isOversea = process.env.DEPLOY_AREA === 'oversea';

/**
 * 点餐页模板
 */
export const DishTheme = {
  DEFAULT: 'default',
  // BIG: 'BIG',
  BIG: 'big',
  HUGE: 'huge',
  TEA: 'tea',
};

export const INDUSTRY = {
  NORMAL: 'normal',
  TEA: 'tea',
};

/**
 * 运行环境.
 * 告知后台查询门店列表用
 */
export const runEnv = {
  GENERAL: 1, // 普通浏览器(除此之外的其他环境)
  WEIXIN: 2, // 微信
  WEIXINMINI: 3, // 微信小程序
  ALI: 4, // 支付宝
};

/**
 * 折扣卡类型
 * 1 可用，2 不可用
 */
export const DISCOUNT_CARD_STATUS = {
  VALID: 1,
  INVALID: 2,
};

// 几种促销的类型定义
export const MULTI_PROMOTIONS = 'multiPromotions'; // 多商品促销
export const MEMBER_PRICE = 'memberPrice'; // 会员价
export const SINGLE_PROMOTIONS = 'singlePromotions'; // 单商品促销
export const FULL_PROMOTIONS = 'fullPromotions'; // 买赠促销
export const FULL_COUNT_PROMOTIONS = 'fullCountPromotions'; // 下一份折扣
export const LIMIT_PROMOTIONS = 'limitPromotions'; // 限免优惠

// 订单详情页-核销码 1 待取餐 2 已取餐
export const TAKE_MEAL_STATUS = {
  MEAL_TOKEN: 2,
  NO_MEAL: 1,
};
export const DISCOUNT_CARDS = 'discountCards';

// 消费税模式（1 附加模式，2 包含模式）
export const TAX_MODE = {
  ADDITIONAL: 1,
  INCLUDE: 2,
};
// 排队类型
export const LINE_STATUS = {
  TABLE: 1, // 显示排队桌数
  POS_ERR: 2, // pos err
  NET_ERR: 3, // net err
};

// 第三方登录 source 值
export const thirdPlatformLoginSource = {
  I_PARK_LOGIN_SOURCE: 20,
};

export const ACCESS_FROM = {
  CCB_APP: 'ccbApp', // 建设银行app
  EBU: 'ebu', // 饿了么
};

// 建行标识
export const CCB_INFO = {
  CCB_PARAM_SJ: 'CCB_PARAM_SJ', // 建行登录密文
  CCB_USER_INFO: 'CCB_USER_INFO', // localstorge中存入建行userid和mobile
  CCB_HEADER: 'CloudMercWebView-User-Agent', // 建行header标志
  CCB_HEADER_IOS: 'iphone',
  CCB_HEADER_ANDROID: 'android',
};
// 饿了么标识
export const EBU_INFO = {
  EBU_EUID: 'euid', // 饿了么euId
};
// 饿了么登录公钥
export const PUBLIC_KEY =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC+s6CloIRGm0kJwvkMbjj2+AL9VMn4YJo6b7H5WFeZA72oa0A7WI/DrBfLrTLx2BTo4iRshYTtETwyv52YcSQN617J9RY9zjZN7rKP8PQmCPgmQ/lobayfia3gPqUxRtaE//i9tDGgtyRraBfE0EhYgJoDyS091l0C4U2SC12h6wIDAQAB';

export const NEW_MINI_PROGRAM_NAME_KEY = 'wxminiprogramname';
export const NEW_MINI_PROGRAM_NAME_VALUE = 'portal-wx-miniprogram';

export const MAP_TYPE = {
  B_MAP: 1, // 百度
  A_MAP: 2, // 高德
  G_MAP: 3, // 谷歌
};

// 业态
export const BUSINESS_TYPE = {
  FAST: 1, // 快餐
  DINNER: 2, // 正餐
  TAKEOUT: 3, // 外卖
  STORE: 4, // 储值
  BAKE: 18, // 烘焙
  DISCOUNT_CARDS: 24, // 折扣卡
  INTEGRAL: 25, // 积分商城
};

// 开台必点策略
export const STRATEGY_TYPE = {
  TABLE: 1, // 按桌台带入
  PEOPLE: 2, // 按人数带入
  SELFCHOOSE: 3, // 开台自选
};

export const SYNC_CART_UNAVAILABLE = 'sync_cart_unavailable';
export const RECONNECTION_ATTEMPTS = 3; // 协同购物车重连次数



// WEBPACK FOOTER //
// ./src/helper/const.js